
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { QuickOrderPositionDto } from "@/dtos/quickOrderPositionDto";
import rules from "@/store/rules";

@Component
export default class QuickOrder extends Vue {
	@Prop()
	private position!: QuickOrderPositionDto;
	private gefilterteArtikel: any = [];
	private articleFilter: string = "";
	private valid: boolean = false;
	private requiredRule = rules.requiredIntegerRule;
	private requiredStringMax10Rule = rules.requiredStringMax10Rule;
	private requiredNumberRule = rules.requiredNumberRule;

	private setArticle(position: any) {
		if (position.description.name != undefined) {
			// Ein Objekt in der Liste wurde ausgewählt
			// Wir speichern aber immer nur den Namen
			position.description = position.description.name;
		}
		console.log(position.description);
	}

	@Watch("articleFilter")
	private async loadArticle() {
		try {
			const generalArticleResponse = await httpClient().get(
				"Article/GetGeneralArticles?" + `searchTerm=${this.articleFilter}`
			);
			for (const iterator of generalArticleResponse.data) {
				iterator.text = iterator.id + " | " + iterator.name;
			}
			this.gefilterteArtikel = generalArticleResponse.data;
		} catch {
			console.error("Load article failed.");
		}
	}

	private getTotal(position: QuickOrderPositionDto) {
		return (position.quantity * position.pricePerUnit).toFixed(2);
	}
}
